import { IconProps } from "../../../types/style";

const CloseSquerSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 44 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2327_6097)">
          <path
            d="M12.5713 28.0715L31.4285 28.0715L31.4285 11.7858L12.5713 11.7858L12.5713 28.0715Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.2113 8.07153H26.7884C30.9484 8.07153 33.4284 10.5515 33.417 14.7115V24.2887C33.417 28.4487 30.937 30.9287 26.777 30.9287H17.2113C13.0513 30.9287 10.5713 28.4487 10.5713 24.2772V14.7115C10.5713 10.5515 13.0513 8.07153 17.2113 8.07153ZM26.2425 24.9549L21.9998 20.7122L17.7572 24.9549C17.4259 25.2862 16.8763 25.2862 16.545 24.9549C16.2137 24.6235 16.2137 24.074 16.545 23.7427L20.7876 19.5L16.545 15.2574C16.2137 14.9261 16.2137 14.3765 16.545 14.0452C16.8763 13.7139 17.4259 13.7139 17.7572 14.0452L21.9998 18.2878L26.2425 14.0452C26.5738 13.7139 27.1233 13.7139 27.4546 14.0452C27.786 14.3765 27.786 14.9261 27.4546 15.2574L23.212 19.5L27.4546 23.7427C27.786 24.074 27.786 24.6235 27.4546 24.9549C27.1233 25.2862 26.5738 25.2862 26.2425 24.9549Z"
            fill={color}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2327_6097"
            x="0.571289"
            y="0.0715332"
            width="42.8457"
            height="42.8572"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2327_6097"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2327_6097"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default CloseSquerSVG;
